import React from "react";
import {QueryClientProvider} from "@tanstack/react-query";
import DashboardWF from "./wf.dashboard";
import AziendaNavContainer from "../../../features/azienda/AziendaNavContainer";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectUser} from "@commons/core.slice";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {queryClient} from "@utilities/config.ReactQuery";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

export const Frame: React.FC = () => {
    //const token = useAppSelector(selectToken);
    const user: UserCRUDRecord | null = useAppSelector(selectUser);
    return <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false}/>
        {user && user.userClass === 'EMPLOYEE' && <DashboardWF/>}
        {user && user.userClass !== 'EMPLOYEE' && <AziendaNavContainer>
            <DashboardWF/>
        </AziendaNavContainer>}
        {/*<React.Suspense fallback={null}>
            <ReactQueryDevtoolsProduction/>
        </React.Suspense>*/}
    </QueryClientProvider>
}
export default Frame;